(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["first_releases/sidebar_order_and_download.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if((env.getFilter("trans").call(context, "first_releases.sidebar_order_url") != "" && env.getFilter("trans").call(context, "first_releases.sidebar_order_title") != "") || (env.getFilter("trans").call(context, "first_releases.sidebar_download_url") != "" && env.getFilter("trans").call(context, "first_releases.sidebar_download_title") != "")) {
output += "\r\n<div id=\"versions\">\r\n<div class=\"box-title\"><h2></h2></div>\r\n<div class=\"box\">\r\n    ";
if(env.getFilter("trans").call(context, "first_releases.sidebar_order_url") != "" && env.getFilter("trans").call(context, "first_releases.sidebar_order_title") != "") {
output += "\r\n        <a href=\"";
output += runtime.suppressValue(env.getFilter("trans").call(context, "first_releases.sidebar_order_url"), env.opts.autoescape);
output += "\" class=\"htmlicon\" target=\"_blank\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "first_releases.sidebar_order_title"), env.opts.autoescape);
output += "</a>\r\n    ";
;
}
output += "\r\n    ";
if(env.getFilter("trans").call(context, "first_releases.sidebar_download_url") != "" && env.getFilter("trans").call(context, "first_releases.sidebar_download_title") != "") {
output += "\r\n        <a href=\"";
output += runtime.suppressValue(env.getFilter("trans").call(context, "first_releases.sidebar_download_url"), env.opts.autoescape);
output += "\" class=\"xlsicon\" target=\"_blank\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "first_releases.sidebar_download_title"), env.opts.autoescape);
output += "</a>\r\n    ";
;
}
output += "\r\n</div>\r\n</div>\r\n";
;
}
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
